<template>
  <div>
    <b-row class="footer-card pull-center">
      <b-col sm="12">
        <span style="margin-right: 10px">
          &copy; {{ new Date().getFullYear() }}
        </span>
        <span style="margin-right: 10px">
          <a href="/"> {{ ownedBy }}</a>
        </span>
        {{ copyRight }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: true,
      developerIntro: "Powered By: ",
      developedBy: "Information Technology",
      ownedBy: "Integrated Cash Management Services Limited",
      copyRight: "All right reserved"
    };
  }
};
</script>

<style lang="scss" scoped>
.footer-card {
  padding: 20px 0;
  font-size: 12px;
  text-transform: uppercase;
  background: #293744;
  color: #ccc;
}
.footer-card a {
  color: #ffffff;
}
.footer-card a:hover {
  text-decoration: none;
}
</style>
